var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6958 1.69727C13.0095 1.69727 15.6958 4.2561 15.6958 7.41258C15.6958 9.23297 14.8023 10.8546 13.4103 11.9012L13.447 11.8734L13.4463 16.1608C13.4463 16.5532 13.0181 16.8125 12.6451 16.646L9.6962 15.3296L6.74882 16.6459C6.37581 16.8125 5.94753 16.5532 5.94753 16.1608L5.94632 11.8748C4.57519 10.8289 3.6958 9.21857 3.6958 7.41258C3.6958 4.2561 6.38209 1.69727 9.6958 1.69727ZM12.3217 12.5529L12.3519 12.5388C11.5512 12.9159 10.6495 13.1279 9.6958 13.1279C8.85174 13.1279 8.04839 12.9619 7.31977 12.6622L7.07215 12.554L7.07253 15.3178L9.45735 14.2527C9.60861 14.1852 9.78356 14.1852 9.93483 14.2527L12.3213 15.318L12.3217 12.5529ZM9.6958 2.76889C7.00341 2.76889 4.8208 4.84794 4.8208 7.41258C4.8208 9.97722 7.00341 12.0563 9.6958 12.0563C12.3882 12.0563 14.5708 9.97722 14.5708 7.41258C14.5708 4.84794 12.3882 2.76889 9.6958 2.76889ZM9.86739 5.01382L10.5518 6.33738L12.0848 6.54839C12.2417 6.57 12.3045 6.75377 12.1909 6.85921L11.0821 7.8883L11.3439 9.34243C11.3707 9.49133 11.2065 9.60483 11.0662 9.53442L9.6958 8.84682L8.32539 9.53442C8.18501 9.60486 8.02081 9.49122 8.04776 9.34228L8.31079 7.8883L7.2008 6.85929C7.08709 6.75387 7.1498 6.57001 7.30685 6.54839L8.83982 6.33738L9.52421 5.01382C9.59432 4.87823 9.79728 4.87823 9.86739 5.01382Z",
    fill: "url(#paint0_linear_8831_20074)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8831_20074",
    x1: 9.6958,
    y1: 1.69727,
    x2: 9.6958,
    y2: 16.6973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A97CDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD6700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.15227de77c618ef84d956915d1f5beb7.svg";
export { ForwardRef as ReactComponent };